import {IController, IModule} from "angular";

const css = require('./inlineMelding.scss');

export class InlineMeldingKomponent implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkInlineMelding', {
                bindings: {
                    type: '@'
                },
                controller: InlineMeldingKomponent.forInjisering(),
                template: require('./inlineMelding.html'),
                transclude: true
            })
    }

    static forInjisering() {
        return [InlineMeldingKomponent]
    }

    type: 'info' | 'advarsel' | 'feil' = 'info';
    typeklasse: string;

    $onInit(): void {
        this.typeklasse = `wk-im-${this.type}`;
    }
}
